// Override webshop.ProductGrid to use tos_webcommerce product card styling
// For all-products page: Dynamic columns based on webcommerce settings

frappe.ready(function() {
	const OriginalProductGrid = webshop.ProductGrid;

	webshop.ProductGrid = class extends OriginalProductGrid {
		constructor(options) {
			super(options);
			this.webcommerce_settings = null;
		}

		async fetchWebcommerceSettings() {
			if (this.webcommerce_settings) {
				return this.webcommerce_settings;
			}

			try {
				const response = await frappe.call({
					method: 'tos_webcommerce.utils.get_webcommerce_context',
					args: {},
					async: true
				});
				
				this.webcommerce_settings = response.message || {};
				return this.webcommerce_settings;
			} catch (error) {
				console.error('Error fetching webcommerce settings:', error);
				return { products_per_row: '4' };
			}
		}

		injectDynamicCSS(products_per_row) {
			const existingStyle = document.getElementById('webcommerce-dynamic-grid');
			if (existingStyle) {
				existingStyle.remove();
			}

			const percentage = (100 / parseInt(products_per_row)).toFixed(6);
			const calcWidth = `calc(${percentage}% - 0.5rem)`;
			const primary_color = this.webcommerce_settings.site_config?.primary_color || '#ffdb56';
			const secondary_color = this.webcommerce_settings.site_config?.secondary_color || '#ECAD4B';
			
			const style = document.createElement('style');
			style.id = 'webcommerce-dynamic-grid';
			style.textContent = `
				/* Set CSS variables for colors */
				:root {
					--primary-color: ${primary_color};
					--secondary-color: ${secondary_color};
				}
				
				/* Dynamic grid layout - Only for desktop screens */
				@media (min-width: 992px) {
					div#products-grid-area.row.products-list .item-card,
					#products-grid-area.row .item-card,
					.item-card-group-section #products-grid-area .item-card,
					#products-grid-area .item-card {
						flex: 0 0 ${percentage}% !important;
						max-width: ${percentage}% !important;
						width: ${percentage}% !important;
						min-width: 0 !important;
						padding-left: 0.25rem !important;
						padding-right: 0.25rem !important;
						box-sizing: border-box !important;
					}
					
					/* Force product card to respect parent width */
					#products-grid-area .item-card .product-card,
					#products-grid-area .item-card .product-item {
						width: 100% !important;
						max-width: 100% !important;
						box-sizing: border-box !important;
					}
				}
			`;
			
			document.head.appendChild(style);
		}

		make() {
			let me = this;
			
			this.fetchWebcommerceSettings().then(webcommerce_settings => {
				const products_per_row = webcommerce_settings.products_per_row || '4';
				me.injectDynamicCSS(products_per_row);
				
				let html = ``;

				me.items.forEach(item => {
					html += me.get_product_card_html(item, me.settings);
				});

				let $product_wrapper = me.products_section;
				$product_wrapper.append(html);
			});
		}

		get_product_card_html(item, settings) {
			let title = item.web_item_name || item.item_name || item.item_code || "";
			let image = item.website_image;
			let discount_percentage = item.discount ? item.discount.replace('%', '').replace(' OFF', '').trim() : null;

			let html = `
				<div class="item-card">
					<div class="product-card h-100">
						<div class="card h-100 border-0 shadow-sm product-item">
							<!-- Product Image with Badges -->
							<div class="product-image-container position-relative">
			`;

			if (image) {
				html += `
					<a href="/${item.route || '#'}" class="text-decoration-none">
						<img src="${image}" alt="${title}" class="card-img-top product-image">
					</a>
				`;
			} else {
				html += `
					<a href="/${item.route || '#'}" class="text-decoration-none">
						<div class="card-img-top product-image-placeholder d-flex align-items-center justify-content-center bg-light">
							<div class="placeholder-icon">${frappe.get_abbr(title)}</div>
						</div>
					</a>
				`;
			}

			if (discount_percentage) {
				html += `
					<div class="discount-badge position-absolute top-0 end-0 m-2">
						<span class="badge bg-danger text-white discount-percent">${discount_percentage}%</span>
					</div>
				`;
			}

			html += `
							</div>
							<!-- Product Info -->
							<div class="card-body p-0 d-flex flex-column">
			`;

			if (item.item_group) {
				html += `<div class="product-brand text-muted small">${item.item_group}</div>`;
			}

			html += `
				<h6 class="product-name d-flex justify-content-between align-items-start">
					<a href="/${item.route || '#'}" class="text-decoration-none text-dark product-link flex-grow-1">
						${title}
					</a>
			`;

			if (!item.has_variants) {
				if (settings.enable_wishlist) {
					let icon_class = item.wished ? "wished" : "not-wished";
					html += `
						<div class="like-action ms-2 ${item.wished ? "like-action-wished" : ''}"
							data-item-code="${item.item_code}" style="cursor: pointer;">
							<svg class="icon icon-sm" style="width: 18px; height: 18px;">
								<use class="${icon_class} wish-icon" href="#icon-heart"></use>
							</svg>
						</div>
					`;
				}
			}

			html += `</h6>`;

			html += `
				<div class="product-rating">
					<div class="stars d-flex align-items-center">
						<span class="text-warning">★★★★★</span>
						<span class="text-muted small ms-1">(0)</span>
					</div>
				</div>
			`;
			if (item.formatted_price) {
				html += `
					<div class="product-pricing mt-auto">
						<div class="price-row d-flex align-items-center flex-wrap gap-1">
							<span class="current-price ${item.formatted_mrp ? 'text-danger' : 'text-primary'} fw-bold mb-0">
								${item.formatted_price}
							</span>
				`;

				if (item.formatted_mrp) {
					html += `
							<span class="original-price text-muted text-decoration-line-through small">
								${item.formatted_mrp}
							</span>
					`;
				}

				html += `
						</div>
					</div>
				`;
			}

			html += `<div class="mt-2 button-container">`;
			
			if (item.has_variants) {
				html += `
					<a href="/${item.route || '#'}" class="btn btn-sm btn-outline-primary w-100">
						${__("Explore")}
					</a>
				`;
			} else if (settings.enabled && (settings.allow_items_not_in_stock || item.in_stock)) {
				html += `
					<div id="${item.name}" class="btn btn-sm btn-primary btn-add-to-cart-list w-100 ${item.in_cart ? 'hidden' : ''}"
						data-item-code="${item.item_code}">
						<span class="me-2">
							<svg class="icon icon-sm">
								<use href="#icon-assets"></use>
							</svg>
						</span>
						${settings.enable_checkout ? __("Add to Cart") : __("Add to Quote")}
					</div>
					<a href="/cart">
						<div id="${item.name}-cart" class="btn btn-sm btn-primary btn-add-to-cart-list w-100 go-to-cart-grid ${item.in_cart ? '' : 'hidden'}"
							data-item-code="${item.item_code}">
							${settings.enable_checkout ? __("Go to Cart") : __("Go to Quote")}
						</div>
					</a>
				`;
			} else {
				html += `
					<button class="btn btn-sm btn-secondary w-100" disabled>
						${__("Unavailable")}
					</button>
				`;
			}
			
			html += `</div>`;

			html += `
							</div>
						</div>
					</div>
				</div>
			`;

			return html;
		}
	};
});
